const SERVICE_WORKER_PATH = "/push-sw.js";

function appShellUrls() {
  const urls = new Set(["/", "/index.html", "/manifest.json"]);
  document.querySelectorAll("script[src]").forEach((node) => {
    const url = new URL(node.src, window.location.origin);
    if (url.origin === window.location.origin) urls.add(`${url.pathname}${url.search}`);
  });
  document.querySelectorAll('link[rel="stylesheet"][href], link[rel="manifest"][href], link[rel~="icon"][href]').forEach((node) => {
    const url = new URL(node.href, window.location.origin);
    if (url.origin === window.location.origin) urls.add(`${url.pathname}${url.search}`);
  });
  return [...urls];
}

export async function registerAbosServiceWorker() {
  if (!("serviceWorker" in navigator) || !window.isSecureContext) return null;
  try {
    const registration = await navigator.serviceWorker.register(SERVICE_WORKER_PATH, { scope: "/" });
    await navigator.serviceWorker.ready;
    registration.active?.postMessage({ type: "CACHE_APP_SHELL", urls: appShellUrls() });
    registration.update().catch(() => {});
    return registration;
  } catch {
    // Online ABOS must remain usable even when a browser refuses service workers.
    return null;
  }
}
